import React from 'react';
import moment from 'moment';

import { useEmployeeQuery as useQuery } from '@jbc-year-end-adj/2024/hooks/graphql/useQuery';
import { LoadingPage } from '@jbc-year-end-adj/2024/components/ui/LoadingPage';

import { FETCH_EXPIRED } from './query';
import styles from './EmployeeExpired.scss';

// @ts-ignore
import image from '@jbc-year-end-adj/2024/images/deadline.svg';
// @ts-ignore
import { Redirect } from 'react-router';

export const EmployeeExpired = () => {
  const { loading, data } = useQuery(FETCH_EXPIRED);
  if (loading) {
    return <LoadingPage />;
  }
  if (!data.request) {
    return <Redirect to="/employee_error?reason=session_expired" />;
  }

  const submissionDeadlineAt = data.clientSetting?.submissionDeadline?.submissionDeadlineAt;
  if (!submissionDeadlineAt || (submissionDeadlineAt && new Date(submissionDeadlineAt) > new Date())) {
    return <Redirect to="/employee_input" />;
  }

  return (
    <div>
      <div className="l-wrap-xs u-pc-pt100 u-sp-pt20">
        <div className={styles.main}>
          <h2 className={styles.title}>提出を締め切りました</h2>
          <h3 className={styles.notice}>
            <p className="m-title-main-note">提出期日: {moment(submissionDeadlineAt).format('YYYY年M月D日 H時')}</p>
            <br />
            <div className={styles.expired}>ご不明な点は管理者までお問い合わせください</div>
          </h3>
          <div className={styles.submissionDeadline}>
            <img src={image} alt="Submission Deadline Icon" />
          </div>
        </div>
      </div>
    </div>
  );
};
